import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Auto-resize iframe when embedded in WordPress
// This sends the current height to the parent window
if (window.self !== window.top) {
  // We're in an iframe
  const sendHeight = () => {
    const height = document.documentElement.scrollHeight;
    window.parent.postMessage({
      type: 'resize',
      height: height
    }, '*');
  };

  // Send height on load
  window.addEventListener('load', sendHeight);

  // Send height when content changes
  const observer = new MutationObserver(sendHeight);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true
  });

  // Send height on window resize
  window.addEventListener('resize', sendHeight);

  // Send height every 500ms as fallback
  setInterval(sendHeight, 500);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
